import classNames from 'classnames';
import React from 'react';
import styles from './Button.module.scss';

export const BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  QUATERNARY: 'quaternary',
  QUINARY: 'quinary',
  SENARY: 'senary',
  SEPTENARY: 'septenary',
  LINK: 'link',
  LINK_QUATERNARY: 'link-quaternary',
  LINK_QUINARY: 'link-quinary',
  LINK_SEPTENARY: 'link-septenary',
  DISABLED: 'disabled',
};

export const BUTTON_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  MEDIUM_WITHOUT_BORDER: 'medium-without-border',
  SMALL: 'small',
};

const Button = ({
  onClick,
  type = BUTTON_TYPE.PRIMARY,
  size = BUTTON_SIZE.LARGE,
  onDoubleClick,
  onMouseOver,
  children,
  disabled = false,
  // pre and post are intended to receive any jsx element to enhance the component
  prebutton,
  postbutton,
  style,
  className,
  onFocus,
  trackerProps = {},
  progress,
}) => (
  <>
    {prebutton}
    <button
      className={classNames(
        { [styles.progressButton]: progress !== undefined },
        styles[size],
        styles[type],
        { [styles[BUTTON_TYPE.DISABLED]]: disabled },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onFocus={onFocus}
      style={style}
      type="button"
      {...trackerProps}
    >
      {progress !== undefined ? (
        <>
          <span
            className={styles.progressFill}
            style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
          />
          <span className={styles.progressContent}>{children}</span>
        </>
      ) : (children)}
    </button>
    {postbutton}
  </>
);

export default Button;
